import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessfulSnackBar, UnsuccessfulSnackBar } from '../@Snackbars';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  public openOkSnackBar(res: any): void {
    this.snackBar.openFromComponent(SuccessfulSnackBar, {
      duration: 3000,
      panelClass: ['snackbar-success', 'custom-snackbar'],
      horizontalPosition: 'center',
      data: res,
    });
  }

  public openFailedSnackBar(data: string = null): void {
    console.log('open snackbar');

    this.snackBar.openFromComponent(UnsuccessfulSnackBar, {
      duration: 3000,
      panelClass: ['snackbar-error', 'custom-snackbar'],
      horizontalPosition: 'center',
      data: data,
    });
  }
}
